module.exports = __webpack_public_path__ + "img/m-4.8d4439e4.png";